import React from 'react';
import Checkbox from '@/components/common/libraries/common/Checkbox';
import Collapse from '@/components/common/libraries/common/Collapse';
import { FilterField } from '@/components/common/libraries/VideoLibrary/types';
import cn from '@/utils/cn';
import styles from './Filter.module.scss';

const Divider = () => <div className={styles.divider} />;

interface FilterProps {
  label: React.ReactNode;
  value: string | number;
  checked: boolean;
  className?: string;
  onChange: (value: string | number, checked: boolean) => void;
}

const Filter = ({ label, value, checked, className, onChange }: FilterProps) => {
  const handleChange = () => {
    onChange(value, !checked);
  };

  return (
    <div className={className ? `${styles.filter} ${className} body sm` : cn(styles.filter, 'body sm')}>
      <Checkbox
        label={label}
        checked={checked}
        extraClassName="hover:tw-text-tci-purple focus:tw-text-tci-purple"
        onChange={handleChange}
        shouldCover
      />
    </div>
  );
};

interface FilterCategoryProps {
  caret?: 'section' | 'row';
  children?: ReactChildren;
  className?: string;
  filterClassName?: string;
  filters?: FilterField[];
  onChange?: (value: string | number, checked: boolean) => void;
  shouldCollapse?: boolean;
  triggerElement: JSX.Element;
}

const FilterCategory = ({
  caret,
  className,
  children,
  filterClassName,
  filters,
  onChange,
  shouldCollapse = true,
  triggerElement,
}: FilterCategoryProps) => (
  <div className={className}>
    <Collapse
      caret={caret}
      shouldCollapse={shouldCollapse}
      triggerElement={triggerElement}
    >
      {children}
      {filters?.map(filter => (
        <Filter
          className={filterClassName}
          key={filter.value}
          label={filter.label}
          value={filter.value}
          checked={filter.checked ?? false}
          onChange={onChange}
        />
      ))}
    </Collapse>
  </div>
);

export {
  Divider,
  FilterCategory,
};

export default Filter;
